"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encryptQueryParams = void 0;

var encryptQueryParams = function encryptQueryParams(object, key) {
  var buffer = Buffer.from(JSON.stringify(object), 'ascii');
  var encryptObject = buffer.toString('base64');
  return "query=".concat(encryptObject);
};

exports.encryptQueryParams = encryptQueryParams;